var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pdf-data",class:{ 'h-100': _vm.isLoading || _vm.isLoadingFile }},[(_vm.isLoading || _vm.isLoadingFile)?_c('Spinner'):_vm._e(),[_vm._t("preview",null,{"pages":_vm.pages}),_vm._t("document",null,{"pages":_vm.pages})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }